module.exports = __webpack_public_path__ + "static/media/Trazado 6672.33adb72c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/Trazado 6672.svg
// module id = 360
// module chunks = 0